import { Container } from "./Container";
import { Modal } from "./Modal";
var defaultContainer;
function prepare() {
    if (!defaultContainer)
        defaultContainer = new Container();
    return defaultContainer;
}
var modalExport = Object.assign(Modal, {
    show: prepare().show.bind(defaultContainer),
    createContainer: function (id) { return new Container(id); },
});
export default modalExport;
